import React from 'react';
import SvgIcon from './SvgIcon';
import { SvgIconProps } from './types';

const LookUpIcon = ({ size = '0.875rem', ...props }: SvgIconProps) => (
    <SvgIcon {...props} size={size} viewBox="0 0 24 24">
        <g
            id="Group-Copy"
            transform="translate(3.000000, 4.000000)"
            fillRule="nonzero"
        >
            <path
                d="M5.84983984,11.4508611 L1.32757153,15.4334191 L0.00576180801,13.9324798 L4.56397306,9.91826843 C3.99420951,8.96778434 3.66666667,7.85547637 3.66666667,6.66666667 C3.66666667,3.16886325 6.50219658,0.333333333 10,0.333333333 C13.4978034,0.333333333 16.3333333,3.16886325 16.3333333,6.66666667 C16.3333333,10.1644701 13.4978034,13 10,13 C8.41245744,13 6.96134094,12.4158906 5.84983984,11.4508611 Z M10,11 C12.3932339,11 14.3333333,9.05990058 14.3333333,6.66666667 C14.3333333,4.27343275 12.3932339,2.33333333 10,2.33333333 C7.60676608,2.33333333 5.66666667,4.27343275 5.66666667,6.66666667 C5.66666667,9.05990058 7.60676608,11 10,11 Z"
                id="Combined-Shape"
            />
        </g>
    </SvgIcon>
);

export default LookUpIcon;
